import _extends from "@babel/runtime/helpers/extends";
import React, { Suspense } from 'react';
import { Box, Loader } from '@wix/design-system';
const TaskStateLazy = /*#__PURE__*/React.lazy(async () => {
  const taskStateModule = await import('./TaskStateWrapper');
  return {
    default: taskStateModule.TaskStateWrapper
  };
});
export const TaskStatusWidget = _ref => {
  let {
    data: {
      statusUrl,
      pollIntervalMs,
      wrapperBoxStyle
    },
    context: {
      httpClient
    }
  } = _ref;
  const boxRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: boxRef,
    direction: "vertical",
    className: "task-status-widget",
    width: "100%",
    maxWidth: "100%"
  }, wrapperBoxStyle), /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      align: "center",
      padding: "10px",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny",
      text: "Loading Code"
    })))
  }, /*#__PURE__*/React.createElement(TaskStateLazy, {
    statusURL: statusUrl,
    httpClient: httpClient,
    pollIntervalMs: pollIntervalMs
  })));
};
export const TASK_STATUS_WIDGET = 'TASK_STATUS_WIDGET';
//# sourceMappingURL=TaskStatusWidget.js.map